export const initialAdvisor = {
  id: -1,
  type: 'ADVISOR',
  name: 'new',
  description: '123',
  is_main: false,
  img: '',
  count: 1,
  u_description: null,
  counter: 1,
  icon_img: '',
  created_at: '',
  upgrades: null,
  max_hex_count: 1,
  locked_count: 0,
  subscription_status: null,
  x: null,
  y: 1,
  hex_count: 1,
  rented: 0,
  is_hibernated: false,
  expired_at: null,
  creates_reports: false,
  last_reports: null,
}
